exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".renderer-container {\n    font-size: 13px;\n    width: 50%;\n    height: 100%;\n}\n.renderer-default {\n    margin-top: 2px;\n    text-overflow: ellipsis;\n    display: block;\n    overflow: hidden;\n    -webkit-user-select: text;\n       -moz-user-select: text;\n        -ms-user-select: text;\n            user-select: text;\n}\n.renderer-default.no-cell-value{\n    width: 100%;\n    height: 100%;\n}\n.hyperlink-content {\n    cursor: pointer;\n    color: #0073AB;\n}\n.lf-svg {\n    width: 15px;\n    height: 15px;\n  }\n\n.statusCellNormal{\n    background: #EDEDED;\n    border-radius: 10px;\n}\n\n.statusCellShipped{\n    background: #DCF6D9;\n    border-radius: 10px;\n}\n\n.statusMBOLError{\n  background:#FCDDE0;\n  border-radius: 10px;\n}\n\n.centerAlignText{\n    display:table;\n    margin-left: auto;\n    margin-right: auto;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/custom-cell-renderer/custom-cell-renderer.component.css
// module id = ../../../../../src/app/shared/components/custom-cell-renderer/custom-cell-renderer.component.css
// module chunks = main